import React, { useContext } from 'react';
import { Link, withRouter, Redirect } from 'react-router-dom';
import { Menu, Icon, Avatar } from 'antd';

import { StoreContext } from '../containers/Store';
import * as ROUTES from '../constants/routes';
import * as ROLES from '../constants/roles';
import logoEvidenceB from '../assets/images/evidenceb_logo.png';
import logoHatier from '../assets/images/hatier_logo.gif';
import StudentImage from '../assets/images/student.png';
import TeacherImage from '../assets/images/teacher.png';
import ILImage from '../assets/images/itineraire_litteraire.jpg';

const linkStyle = {
  textDecoration: 'none',
  color: 'white',
  textAlign: 'right',
  paddingLeft: '12px',
  paddingRight: '12px'
};

const NavH = ({ location: { pathname } }) => {
  const { 
    user: { user: authUser },
  } = useContext(StoreContext);

  return (
    <div style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginLeft: '50px'}}>
      {window.innerWidth > 520 &&
        authUser && authUser.roles.includes(ROLES.STUDENT_DEMO) && <Avatar src={StudentImage} style={{ backgroundColor: 'white' }}/>}
      {window.innerWidth > 520 &&
        authUser && authUser.roles.includes(ROLES.TEACHER_DEMO) && <Avatar src={TeacherImage} style={{ backgroundColor: 'white' }}/>}
      {window.innerWidth > 520 &&
      authUser && pathname !== '/' &&
        <Link to={ROUTES.LOGOUT} style={linkStyle}>Se déconnecter</Link>}
      {window.innerWidth < 520 &&
        authUser && authUser.roles.includes(ROLES.STUDENT_DEMO) &&
        <Avatar src={StudentImage} style={{ height: '50%', backgroundColor: 'white' }} />}
      {window.innerWidth < 520 &&
        authUser && authUser.roles.includes(ROLES.TEACHER_DEMO) &&
        <Avatar src={TeacherImage} style={{ height: '50%', backgroundColor: 'white' }} />}
      {window.innerWidth < 520 &&
        authUser && pathname !== '/' &&
        <Link to={ROUTES.LOGOUT} style={linkStyle}><Icon type="logout" /></Link>}
    </div>
  );
};

export const NavigationHorizontale = withRouter(NavH);

const NavV = ({ location: { pathname } }) => {
  const { user: { user: authUser } } = useContext(StoreContext);
  const mapKeysStudent = (pathname) => {
    switch (pathname) {
      case ROUTES.CHATBOT:
        return ['1'];
      case ROUTES.PATH:
        return ['2'];
      case ROUTES.DASHBOARD:
        return ['3'];
      default:
        return ['1'];
    }
  }
  const mapKeysTeacher = (pathname) => {
    switch (pathname) {
      case ROUTES.DASHBOARD:
        return ['1'];
      case ROUTES.CHATBOT:
        return ['2'];
      default:
        return ['1'];
    }
  }
  
  return (
      <div>
        { authUser && authUser.roles.includes(ROLES.STUDENT_DEMO) && <Menu
          mode="inline"
          defaultSelectedKeys={mapKeysStudent(pathname)}
          defaultOpenKeys={['sub1']}
          style={{ height: '100%', borderRight: 0 }}>
          <Menu.Item key="1">
            <Link to={ROUTES.CHATBOT}>
              <Icon type="robot" />
              <span> Module </span>
            </Link>
          </Menu.Item>
          <Menu.Item key="2">
            <Link to={ROUTES.PATH}>
              <Icon type="rise" />
              <span> Parcours </span>
            </Link>
          </Menu.Item>
          <Menu.Item key="3">
            <Link to={ROUTES.DASHBOARD}>
            <Icon type="dashboard" />
              <span> Tableau de bord </span>
            </Link>
          </Menu.Item>
        </Menu>
        }
      { authUser && authUser.roles.includes(ROLES.TEACHER_DEMO) && <Menu
          mode="inline"
          defaultSelectedKeys={mapKeysTeacher(pathname)}
          defaultOpenKeys={['sub1']}
          style={{ height: '100%', borderRight: 0 }}>
          <Menu.Item key="1">
            <Link to={ROUTES.DASHBOARD}>
              <Icon type="dashboard" />
              <span> Tableau de bord </span>
            </Link>
          </Menu.Item>
          <Menu.Item key="2">
            <Link to={ROUTES.GALLERY}>
              <Icon type="robot" />
              <span> Plan du module </span>
            </Link>
          </Menu.Item>
        </Menu>
      }
    </div>
  );
};

export const NavigationVerticale = withRouter(NavV);

export const NavigationHomeEvidenceB = () => {
  const { user: { user: authUser } } = useContext(StoreContext);
  return (
    <div> 
      <div style={{ display: 'flex'}}>
        <a href='https://www.editions-hatier.fr/'>
          <div
            style={{
              width: '60px',	
              height: '64px',
              backgroundColor: '#000'
            }}
          >
            <div	
              style={{	
                width: '60px',	
                height: '60px',
                backgroundImage: `url(${logoHatier})`
              }} />
          </div>
        </a>
        <a href='http://www.evidenceb.com/'>
          <img
            src={logoEvidenceB}
            alt='logoEvidenceB'
            width='100px'
            style={{ marginLeft: '16px'}}
          />
        </a>
      </div>
      {window.innerWidth > 520 && <div style={{ position: 'relative', left: '200px', top: '-68px'}}> 
        <a href='https://www.itineraireslitteraires.fr/'>
          <img
            src={ILImage}
            alt='logoEvidenceB'
            width='400px'
            style={{ marginLeft: '16px'}}
          />
          </a>
      </div>}
    </div>
  );
};

export const NavigationHomeHatier = () => {
  const { user: { user: authUser } } = useContext(StoreContext);
  return (
    <a href='https://www.editions-hatier.fr/'>
      <img
        src={logoHatier}
        alt='logoHatier'
        width='50px'
      />
    </a>
  );
};
